import { mapActions, mapState } from "vuex/dist/vuex.common.js";
export default {
  data() {
    return {
      securityModel: 0,
      effectiveScope: 1,
      model: [{
        value: 0,
        text: $t("lb5z2", "禁用")
      }, {
        value: 2,
        text: $t("ccueqd4", "强制启用")
      }, {
        value: 1,
        text: $t("eymx2", "启用")
      }],
      // state 21表示全局启用针对全部用户，20代表全局启用针对管理员
      userList: [{
        value: 1,
        text: $t("ctrxqw4", "所有用户")
      }, {
        value: 0,
        text: $t("ominoi5", "针对管理员")
      }]
    };
  },
  methods: {
    ...mapActions(["reqMFAConfigs", "updateMFAConfigs"]),
    // 启用MFA
    async enableMFA(state) {
      let stateStr = null;
      if (state == 2) {
        // 全局启用要带上覆盖范围
        stateStr = state.toString().concat(this.effectiveScope);
      } else {
        stateStr = state;
      }
      let res = await this.updateMFAConfigs({
        state: stateStr
      });
      if (res === 0) {
        this.$Message.success($t("d1spvi4", "操作成功"));
      }
    },
    async enableMFAScope(state) {
      let res = await this.updateMFAConfigs({
        state: this.securityModel.toString().concat(state)
      });
      if (res === 0) {
        this.$Message.success($t("d1spvi4", "操作成功"));
      }
    }
  },
  computed: {
    ...mapState({
      personalConfig: state => state.user.personalConfig
    })
  },
  async mounted() {
    let {
      state
    } = await this.reqMFAConfigs();
    this.securityModel = Number(state.toString()[0]);
    this.effectiveScope = Number(state.toString()[1] || 0);
  }
};